/**
 * `/market/orders/$orderId` — one order, and the only place a refund can be asked for.
 *
 * The id is not validated here. The gateway answers a malformed id exactly the way it
 * answers an id that names nothing and an id belonging to somebody else — one body, one
 * status — so a client-side format check would only move the refusal earlier and give the
 * three answers different shapes.
 */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/market/orders/$orderId')({});
